<template>
  <div>
    <div class="hader">
      <p>
        <span>{{ Number(anIndex) + 1 }}</span>
        [{{ TestItems.Style }}]
      </p>
      <p v-html="TestItems.Title"></p>
    </div>
    <div class="main">
      <template v-if="!practice">
        <el-radio-group v-model="TestItems.UserAnswer">
          <el-radio label="对" size="small" @change="saveAnswer()"
            >A.对</el-radio
          >
          <el-radio label="错" size="small" @change="saveAnswer()"
            >B.错</el-radio
          >
        </el-radio-group>
      </template>
      <template v-if="practice">
        <div class="practice_view">
          <!-- 练习状态 -->
          <ul>
            <li
              v-for="(item, index) in SelectedItems"
              :key="index"
              @click="saveAnswer(item.Content)"
            >
              <img
                src="@/assets/student/choice.png"
                alt=""
                v-if="practiceColour(item) === 'green'"
              />
              <img
                src="@/assets/student/errorx.png"
                alt=""
                v-else-if="practiceColour(item) === 'red'"
              />
              <div class="default" v-else></div>
              <p :class="practiceColour(item)">
                {{ item.ItemName + "." }}
                <span v-html="item.Content"> </span>
              </p>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      SelectedItems: [
        {
          ItemName: "A",
          Content: "对",
        },
        {
          ItemName: "A",
          Content: "错",
        },
      ],
    };
  },
  props: ["TestItems", "anIndex", "userAbswerArr", "practice"],
  methods: {
    // 保存答案
    saveAnswer(item) {
      if (this.practice){
        this.TestItems.UserAnswer = item
      }
      const AbswerObj = {
        TestID: this.TestItems.TestID,
        ChildTableID: this.TestItems.TestID,
        UserAnswer: this.TestItems.UserAnswer,
        Score: this.TestItems.Score,
        IsRight:
          this.TestItems.UserAnswer === this.TestItems.Answer,
      };
      this.$emit("userAbswer", AbswerObj);
      console.log(AbswerObj,'www');
    },
    // 回显用户刷新保存上次答案
    theEchoAbswer() {
      this.userAbswerArr.forEach((item) => {
        if (item.TestID == this.TestItems.TestID) {
          this.TestItems.UserAnswer = item.UserAnswer;
        }
      });
      console.log(this.TestItems.UserAnswer);
    },
  },
  computed: {
    practiceColour() {
      return function (item) {
        if (this.TestItems.UserAnswer && this.practice) {
          // 练习才触发
          if (
            this.TestItems.UserAnswer == this.TestItems.Answer &&
            item.Content == this.TestItems.UserAnswer
          ) {
            // 答案正确且相同
            return "green";
          }
          if (
            this.TestItems.UserAnswer != this.TestItems.Answer
          ) {
            // 答案错误且相同
            if (this.TestItems.Answer == item.UserAnswer) {
              return "green";
            } else if (item.Content == this.TestItems.UserAnswer) {
              return "red";
            } else {
              return "";
            }
          } else {
            return "";
          }
        } else {
          return "";
        }
      };
    },
  },
  activated() {
    this.theEchoAbswer();
  },
};
</script>

<style lang="scss" scoped>
.hader {
  height: 68px;
  display: flex;
  align-items: center;
  background: #f7f7f7;
  user-select: none;
  p {
    margin-right: 4px;
    &:nth-child(1) {
      color: #119ce5;
      font-weight: bold;
      span {
        font-size: 150%;
        font-weight: bold;
        margin: 0px 18px 18px 22px;
      }
    }
  }
}
.main {
  padding: 36px 30px;
  user-select: none;
  ::v-deep .el-radio-group {
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    .el-radio__label {
      font-size: 18px;
    }
    .el-radio {
      margin-top: 30px;
    }
  }
}
.green {
  color: rgb(1, 207, 151);
}
.red {
  color: #ee4f3b;
}
.practice_view {
  > ul {
    list-style-type: none;
    > li {
      display: flex;
      align-items: center;
      font-size: 20px;
      margin-bottom: 12px;
      cursor: pointer;
      > img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      .default {
        border: 2px solid #d1dde4;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-right: 10px;
        // margin-top:12px;
      }
    }
  }
}
</style>
